<template>
  <div>
    <v-dialog v-model="dialog" width="500">
      <v-card style="border-radius:18px">
        <v-container
          style="height:100%"
          class="d-flex justify-center align-center flex-column"
        >
          <v-card-title
            style="word-break:normal"
            class="d-flex justify-center text-center headline lighten-2 text-uppercase"
            primary-title
          >
            {{ $t("equipmentList.scanAndInspect") }}
          </v-card-title>

          <v-card-text class=" mt-4 text-center">
            <qrcode-stream
              v-if="dialog"
              @decode="onDecode"
              @init="onInit"
            ></qrcode-stream>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="closeDialog">
              {{ $t("equipmentList.cancel") }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-app-bar app>
      <v-app-bar-nav-icon
        v-if="
          $store.getters['auth/isLogged'] && $store.getters['auth/isVerified']
        "
        class="systembar-buttom"
        @click.stop="drawer = !drawer"
      >
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-img
        class="hidden-xs-only shrink mr-2 cursor-pointer"
        contain
        src="@/assets/logo.png"
        transition="scale-transition"
        height="64"
        width="auto"
        @click="$router.push('/')"
      />
      <v-spacer></v-spacer>
      <span
        :class="
          $vuetify.theme.dark
            ? 'font-weight-bold'
            : 'primary--text font-weight-bold'
        "
      >
        {{ $t("equipmentList.pilot") }}</span
      >
    </v-app-bar>
    <v-navigation-drawer
      v-if="!$store.getters['auth/isEmpty']"
      :style="$vuetify.theme.dark ? '' : 'background-color:#E0E0E0'"
      v-model="drawer"
      v-bind:width="280"
      app
      floating
      class="elevation-1"
    >
      <v-img
        class="mx-auto my-2 border-radius-50 cursor-pointer"
        position
        @click="$router.push('/')"
        src="@/assets/logo.png"
        max-width="200"
      ></v-img>

      <v-divider class="mb-1" />

      <v-list dense nav>
        <base-item-group :text="true" :item="profile" />
      </v-list>

      <v-divider class="mb-2" id="#drawing" />

      <v-list dense active-class="green--text ">
        <v-list-item to="/">
          <v-list-item-action>
            <v-icon>mdi-view-module</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("navigationBar.dashboard") }}
              <v-chip x-small class="ml-2" label color="primary">{{
                $t("navigationBar.new")
              }}</v-chip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group
          active-class="green--text "
          no-action
          prepend-icon="mdi-puzzle"
        >
          <template v-slot:activator>
            <v-list-item-title>
              {{ $t("navigationBar.module") }}
            </v-list-item-title>
          </template>
          <v-list-item to="/equipment-list">
            <v-list-item-title>
              {{ $t("navigationBar.titles.assets") }} </v-list-item-title
            ><v-list-item-icon>
              <v-icon>mdi-cogs</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item to="/works" v-if="$store.getters['auth/equipmentWrite']">
            <v-list-item-title>
              {{ $t("navigationBar.titles.CAO") }}
              <v-chip x-small class="ml-2" label color="primary">
                {{ $t("navigationBar.new") }}</v-chip
              > </v-list-item-title
            ><v-list-item-icon>
              <v-icon>mdi-account-hard-hat</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item
            to="/stocks"
            v-if="$store.getters['auth/equipmentWrite']"
          >
            <v-list-item-title>
              {{ $t("navigationBar.titles.stocks") }}
              <v-chip x-small class="ml-2" label color="primary">{{
                $t("navigationBar.new")
              }}</v-chip> </v-list-item-title
            ><v-list-item-icon>
              <v-icon>mdi-clipboard-list</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item to="/calendar">
            <v-list-item-title>
              {{ $t("navigationBar.titles.calendar") }}
              <v-chip x-small class="ml-2" label color="primary">{{
                $t("navigationBar.new")
              }}</v-chip> </v-list-item-title
            ><v-list-item-icon>
              <v-icon>mdi-calendar</v-icon>
            </v-list-item-icon>
          </v-list-item></v-list-group
        >
        <v-list-group
          active-class="green--text "
          no-action
          prepend-icon="mdi-qrcode-scan"
        >
          <template v-slot:activator>
            <v-list-item-title>
              {{ $t("equipmentList.scanQR") }}
            </v-list-item-title>
          </template>
          <v-list-item @click="openScan('inspection')">
            <v-list-item-title
              >{{ $t("equipmentList.inspections") }}
            </v-list-item-title>
            <v-list-item-icon>
              <v-icon> mdi-clipboard-text-outline</v-icon>
            </v-list-item-icon>
          </v-list-item>

          <v-list-item
            v-if="$store.getters['auth/reliabilityWrite']"
            @click="openScan('reliability')"
          >
            <v-list-item-title>
              {{ $t("equipmentList.reliability") }}
            </v-list-item-title>
            <v-list-item-icon>
              <v-icon> mdi-clipboard-check-outline</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item @click="openScan('repairLog')">
            <v-list-item-title>
              {{ $t("equipmentList.repair-logs") }}
            </v-list-item-title>
            <v-list-item-icon>
              <v-icon> mdi-hammer-wrench</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
        <v-list-group
          v-if="$store.getters['auth/adminAndUp']"
          active-class="green--text "
          no-action
          prepend-icon="mdi-plus-circle"
        >
          <template v-slot:activator>
            <v-list-item-title>{{ $t("navigationBar.new") }}</v-list-item-title>
          </template>
          <v-list-item to="/new/equipment" link>
            <v-list-item-title
              >{{ $t("navigationBar.equipment") }}
            </v-list-item-title>
            <v-list-item-icon>
              <v-icon>mdi-cogs</v-icon>
            </v-list-item-icon>
          </v-list-item>

          <v-list-item link to="/register">
            <v-list-item-title
              >{{ $t("navigationBar.user") }}
            </v-list-item-title>
            <v-list-item-icon>
              <v-icon>mdi-account-plus</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
        <v-list-item
          v-if="$store.getters['auth/userWrite']"
          to="/users-list"
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("navigationBar.userList") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/tickets">
          <v-list-item-action>
            <v-icon>mdi-alert-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("equipmentList.reportError") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="signOut()">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              >{{ $t("navigationBar.signOut") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main class="mb-12">
      <v-container fluid> <slot></slot></v-container>
    </v-main>

    <v-footer app inset>
      <v-spacer></v-spacer>

      <v-bottom-sheet v-model="sheet" v-if="!($route.name === 'Login')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark v-bind="attrs" v-on="on">
            <v-icon> mdi-qrcode-scan</v-icon>
          </v-btn>
        </template>
        <v-list color="primary" dark>
          <v-subheader class="font-weight-bold">Open</v-subheader>
          <v-divider></v-divider>
          <v-list-item
            @click="openScan(tile.actions)"
            v-for="tile in tiles"
            :key="tile.title"
          >
            <v-list-item-avatar>
              <v-icon>{{ tile.icon }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-title>{{ tile.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-bottom-sheet>

      <v-spacer></v-spacer>
    </v-footer>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { QrcodeStream } from "vue-qrcode-reader";

export default {
  components: {
    QrcodeStream
  },
  data() {
    return {
      result: "",
      error: "",
      fab: false,
      dialog: false,
      sheet: false,
      drawer: false,
      group: null,
      tiles: [
        {
          icon: "mdi-clipboard-text-outline",
          title: this.$t("equipmentList.inspections"),
          actions: "inspection"
        },
        {
          icon: "mdi-clipboard-check-outline",
          title: this.$t("equipmentList.reliability"),
          actions: "reliability"
        },
        {
          icon: "mdi-hammer-wrench",
          title: this.$t("equipmentList.span-new-repair-logs"),
          actions: "repairLog"
        }
      ],
      adds: [
        [" Equipment", "mdi-cogs", "/new/equipment"],
        [" Equipment Type", "mdi-engine", "/new/equipment-type"]
      ]
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
    profile() {
      return {
        avatar: true,
        title: this.user.firstName + " " + this.user.lastName,
        group: "",
        children: [
          {
            icon: "mdi-account-cog",
            to: "user-profile",
            title: this.$t("navigationBar.titles.userProfile")
          }
        ]
      };
    }
  },

  watch: {
    group() {
      this.drawer = false;
    }
  },
  methods: {
    openScan(item) {
      switch (item) {
        case "inspection":
          this.routeName = "New/Inspection";
          this.dialog = true;
          this.sheet = false;
          break;

        case "reliability":
          this.routeName = "New/Reliability";
          this.dialog = true;
          this.sheet = false;
          break;
        case "repairLog":
          this.routeName = "New/RepairLog";
          this.dialog = true;
          this.sheet = false;
          break;
        default:
          this.routeName = "New/Inspection";
          this.dialog = true;
          this.sheet = false;
          break;
      }
    },
    async onDecode(result) {
      await this.$router.push({
        name: this.routeName,
        params: { equipId: result }
      });
      this.dialog = false;
      this.sheet = false;
    },
    closeDialog() {
      this.dialog = false;
      this.sheet = false;
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
        }
      }
    },
    async signOut() {
      const loading = this.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });
      try {
        await this.$store.dispatch("auth/SIGN_OUT").then(() => {
          this.$router.push("login");
        });
      } catch (error) {
        console.error(error);
      } finally {
        loading.close();
      }
    }
  }
};
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}
</style>
